module.exports = __webpack_public_path__ + "img/img_logo_white.4f9be7c9.svg";